import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { CaptainDAO } from '../../../../../core/services/dao/captainDAO';
import { DiscountDAO } from '../../../../../core/services/dao/discountDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class CaptainInfoResolve implements Resolve<any> {
  constructor(
    private captainDAO: CaptainDAO,
    private router: Router,
    private discountDAO: DiscountDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const captainResolve = this.captainDAO.loadCaptainForHireById(
      route.params.id,
    );
    const discountResolve = this.discountDAO.load();
    const mergeResolve = merge(captainResolve, discountResolve);
    return combineLatest([captainResolve, discountResolve]).pipe(
      map(([captainResolve, discountResolve]) => ({
        captainResolve,
        discountResolve,
      })),
      take(1),
    );
  }
}
